import Footer from "../../../components/Footer/Footer";
import NavBar from "../../../components/NavBar/NavBar";

import Title from "../../../components/Title/Title";
import CustomButton from "../../../components/Custom-Button/CustomButton";

export default function FifthCommandment() {

    return (
        <div>
            <NavBar/>
            <Title text={"Não Matarás"}/>

            <p className="info-text">
                Este mandamento proíbe toda ofensa injusta à vida humana. O Catecismo afirma que a vida humana é sagrada desde a concepção e pertence somente a Deus (unico “Senhor da vida”)[51]. <br/>
                Matar um inocente é gravemente contrário à dignidade da pessoa (por ser feita à imagem de Deus)[52]. <br/>
                Cristo no Sermão da Montanha ampliou o mandamento, condenando também a ira e o ódio que levam ao homicídio[53]. <br/>
                Reconhece-se, porém, a legítima defesa: é lícito defender-se de um agressor mesmo causando-lhe a morte, desde que proporcional e por amor à própria vida (cf. CIC 2263-2265)[54]. <br/>
                A autoridade estatal pode punir crimes com penas proporcionais (histórica discussão sobre pena de morte), mas hoje a Igreja ensina que a pena capital é geralmente inadmissível (2018) por respeitar a inviolabilidade da pessoa[55]
            </p> 

            <Title text={"Aplicação Cotidiana"}/>
            <p className="info-text">
                Viver este mandamento inclui respeitar a vida em todas as suas fases. <br/> 
                No cotidiano, isso significa rejeitar a violência (física, verbal, psicológica), o aborto e a eutanásia – consideradas gravemente contrárias à lei moral[56][57] – e repudiar o suicídio (cooperar com a vida que Deus deu). <br/>
                Implica também combater causas indiretas de morte: por exemplo, ajudar a combater a fome, a injustiça social e a exploração que levam ao sofrimento e à morte alheia[58]. <br/>
                Respeitar os outros inclui praticar caridade (visitar doentes, cuidar de dependentes, orar pela paz), evitando gestos de desamor. Apoiar leis e políticas que protejam a vida (sanções contra homicídio, investimento em saúde, segurança pública) está em conformidade com a Doutrina Social da Igreja.
            </p> 

            <Title text={"Aspectos Teológicos"}/>

            <p className="info-text">
                Este mandamento lembra que Deus é a fonte da vida[51]. A humanidade, criada por amor, só encontra plenitude à luz de sua esperança em Deus, e matar nega esse laço divino. <br/> 
                O CIC destaca episódios bíblicos: Caim e Abel (Gn 4) e o Dilúvio (Gn 9) para afirmar a inviolabilidade da vida humana[59][52]. <br/>
                É também mandamento do amor: amar o próximo é cumpri-lo na plenitude (Rm 13,9)[10]. <br/>
                A Igreja ensina que a vida deve ser protegida “do momento da concepção até a morte natural”[60]. <br/>
                Em Cristo, a dignidade da vida é reafirmada pelo mandamento do amor e pelo exemplo de paciência e perdão. <br/>
                Por fim, há no mandamento um princípio de justiça e misericórdia: a defesa do inocente deve ocorrer, mas sempre visando a caridade e a verdade (cf. legítima defesa)[54]
            </p> 

            <CustomButton route={"/Mandamentos"} text={"Voltar"}/>
            <Footer/>
        </div>
    )
}